import { getClientEnv } from '../repositories/clientEnvRepository'

const PREFIXES_TO_CHECK = ['RAILS_', 'NEXT_PUBLIC_']

export function getEnvVar(key: string): unknown | undefined {
  return [key, ...PREFIXES_TO_CHECK.map((prefix) => `${prefix}${key}`)]
    .map((k) => getClientEnv()[k])
    .find((v) => typeof v !== 'undefined')
}
